__webpack_require__.p = "/CoffeeShop/";